import type { FaireProductEntity } from "../../entity_types/product";

export const p_sadtje7ujt: FaireProductEntity = {
  token: "p_sadtje7ujt",
  type: "product",
  name: "All-Natural Sea Salt - Lemon - 2 oz",
  brandToken: "b_4l4trvmb",
  brandName: "Salt Sisters",
  imageUrl:
    "https://cdn.faire.com/fastly/a049b4c5156b07df9fc4ee15eadaecfd3aba8847b007e92cd0dd86226336a8fa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6798169f62eac7e6168c9c9ad0e00ce708f8033a3d32f8b6a11bc0b294246a12.jpeg",
    "https://cdn.faire.com/fastly/7c0603792f9d8882209b89025289f47c9d71320b56c62a23b6cb0d9c653fd6b9.jpeg",
    "https://cdn.faire.com/fastly/b289db257fc778c50f328011f0edf64a846f9104746e799db7af7654c13a9006.jpeg",
    "https://cdn.faire.com/fastly/5b256249b55e1e369acbdc6dd6801a87665356a2e92c2587cdbbeb35c9c94386.webp",
  ],
  priceDollars: 5.49,
  description:
    "This refreshing sea salt blend combines solar-evaporated sea salt with real lemon for a bright, tangy flavor. The tart citrus twist pairs beautifully with the salt's crisp, flaky texture, creating a well-balanced seasoning that’s both versatile and delicious.\n\nIdeal for seafood, confections, and cocktails, this salt adds a zesty finish to everything from snack foods to gourmet dishes.\n\n*  Zesty Lemon Boston Lettuce Salad recipe on back.\n\nOur USA made, farm to table products contain no MSG, no preservatives and are non-GMO, making them a great idea for host / hostess gifts or as a way to elevate special events such as game day, family gatherings and holidays.\n\nSeason your spring with s.a.l.t. sisters’ all-natural products! Whether you’re attending an Easter dinner, Mother's Day Brunch, Father's Day BBQ or a graduation party, our award-winning collection, will transform your dishes into culinary masterpieces filled with love and flavor.",
  tags: [],
  msrpDollars: 11.07,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:56.292Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
